import { css, cssManager } from '@design.estate/dees-element';
import { themeDefaultStyles } from '../../00theme.js';

export const chartAreaStyles = [
    themeDefaultStyles,
    cssManager.defaultStyles,
    css`
      :host {
        display: block;
        height: 400px;
        font-family: system-ui, 'Segoe UI', 'Roboto', sans-serif;
        color: var(--dees-color-text-primary);
        font-size: 14px;
      }
      dees-tile {
        height: 100%;
      }
      .chartHeader {
        display: flex;
        align-items: center;
        height: 32px;
        padding: 0 8px 0 16px;
      }
      .chartLabel {
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: -0.01em;
        color: var(--dees-color-text-secondary);
      }
      .expandBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border: none;
        border-radius: 4px;
        background: transparent;
        cursor: pointer;
        color: var(--dees-color-text-muted);
        transition: all 0.15s ease;
        padding: 0;
      }
      .expandBtn:hover {
        background: var(--dees-color-hover);
        color: var(--dees-color-text-secondary);
      }
      .chartContainer {
        position: absolute;
        inset: 0 0 4px 0;
      }
      .rangeSelectionOverlay {
        position: absolute;
        display: none;
        top: 0;
        bottom: 0;
        z-index: 3;
        pointer-events: none;
        background: color-mix(in srgb, var(--dees-color-accent, #3b82f6) 18%, transparent);
        border-inline: 1px solid color-mix(in srgb, var(--dees-color-accent, #3b82f6) 70%, transparent);
      }
      .statsBar {
        min-height: 32px;
        padding: 4px 16px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 4px 24px;
        width: 100%;
        box-sizing: border-box;
      }
      .statsSeries {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .statsSeries + .statsSeries {
        padding-left: 24px;
        border-left: 1px solid var(--dees-color-border-default);
      }
      .statsColor {
        width: 8px;
        height: 8px;
        border-radius: 2px;
        flex-shrink: 0;
      }
      .statsName {
        font-weight: 500;
        font-size: 11px;
        color: var(--dees-color-text-secondary);
        margin-right: 4px;
      }
      .statsItem {
        font-size: 11px;
        color: var(--dees-color-text-muted);
      }
      .statsItem strong {
        color: var(--dees-color-text-primary);
      }
      .lw-tooltip {
        position: absolute;
        z-index: 100;
        pointer-events: none;
        padding: 12px;
        border-radius: 6px;
        border: 1px solid;
        font-family: system-ui, 'Segoe UI', sans-serif;
        font-size: 12px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
        min-width: 140px;
      }
    `,
  ];
